export default {
  solarAgreementDescNoGratis: 'Tilføj solcelleaftale til din elaftale',
  heroTitle1: 'Elaftaler til',
  heroTitle2: 'skarpe priser',
  heroSubtitle: 'Billig strøm til lav elpris. Spar penge på el med gennemsigtig timepris – fra kun 18 kr./md.',
  heroNote: '*Du kan også bruge enkel energi som dit normale elselskab – ',
  heroNoteHighlight: 'helt uden elbil',
  seeElAftaler: 'Se elaftaler',
  chooseElAftale: 'Vælg din elaftale',
  chooseYourElAftale: 'Vælg din elaftale',
  andSaveAvg18: 'enkel strøm',
  enkelStrom: 'enkel strøm – vælg bare de tilvalg, der passer dig',
  needCharger: 'Har du brug for en ladeboks?',
  clickHere: 'Klik her',

  // Product names
  enkelKvartal: 'enkel kvartal',
  enkelStromName: 'enkel strøm',
  enkelNatur: 'enkel natur',

  // Card content
  spotPriceNoMarkup: 'El spotpris uden tillæg',
  spotPriceWithMarkup: 'Variabel elpris + 0,02 kr./kWh',
  quarterlyPayment: 'Kvartalsvis Aconto betaling',
  monthlyPayment: 'Månedlig Aconto betaling',
  freeSmartCharge: 'Saving Mode inkluderet',
  noNotice: 'Ingen binding',
  quarterlyBilling: 'Kvartalsvis afregning',
  monthlyBilling: 'Månedlig afregning',
  natureDonation: '20 kr./md til danske naturprojekter',
  aconto: 'Aconto',
  forbrug: 'Forbrug',
  from2026: '*Fra 2026',
  
  // Product explanations
  kvartalExplanation: 'Billig strøm med kvartalsvis afregning',
  stromExplanation: 'Billig el med månedlig betaling',
  naturExplanation: 'Billigere strøm + støtte til dansk natur',

  // Add-ons
  consumptionBilling: 'Forbrugsafregning',
  consumptionBillingDesc: '',
  addSolar: 'Tilføj',
  solarAgreement: 'solcelleaftale',
  onlySolar: 'Vil du kun have en solcelleaftale?',

  // Pricing
  subscriptionIncluded: 'Abonnement inkluderet i prisen',
  priceCalculation: 'Prisberegning',
  subscription: 'Abonnement',
  perMonth: '/måned',
  priceNote: 'Prisen på {price} er gennemsnitsprisen inkl. abonnement, baseret på et forbrug på 7.500 kWh/halvår',
  noBindingInfo: 'Ingen binding',
  supportsNature: 'Støtter aktiv naturbeskyttelse i Danmark',

  // Solar popup
  solarPopupTitle: 'Produktionsaftale (Solcelleaftale)',
  solarPopupIntro: 'Produktionsaftale uden leverandørgebyrer når du bruger enkel som din elleverandør.',
  solarPopupDesc: 'Vi afregner automatisk dit overskydende solcellestrøm til markedspris minus lovpligtige omkostninger og transportgebyrer.',
  solarPopupNotice: 'Opsigelsesperiode: løbende måned + 1 måned.',
  solarPopupGroup6Warning: 'Afregningsgruppe 6 kan ikke overtages.',
  solarPopupConfirmClose: 'Bekræft og luk',
  freeServiceQuestion: 'Gratis Serviceaftale?',
  serviceAgreement: 'Serviceaftale',
  servicePopupTitle: 'Gratis Serviceaftale',
  servicePopupIntro: 'Med din elaftale får du gratis serviceaftale på din ladeboks.',
  servicePopupDesc: 'Serviceaftalen dækker support og fejlfinding på din ladeboks via vores app og kundeservice. Du får hjælp til opsætning, Saving Mode og daglig brug.',
  servicePopupBrands: 'Gælder alle Easee, NexBlue og Zaptec ladebokse – både eksisterende og nye købt sammen med elaftale fra enkel.',
  servicePopupNote: 'Serviceaftalen er inkluderet så længe du er el-kunde hos enkel energi.',
  servicePopupConfirm: 'Forstået',
  serviceAgreementIncluded: 'Serviceaftale inkluderet',
  solarPopupDesc1: 'Produktionsaftale uden leverandørgebyrer når du bruger enkel som din elleverandør.',
  solarPopupDesc2: 'Vi afregner automatisk dit overskydende solcellestrøm til markedspris minus lovpligtige omkostninger og transportgebyrer.',
  solarPopupDesc3: 'Opsigelsesperiode: løbende måned + 1 måned.',

  // Schema metadata
  schemaName: 'Billig elaftale fra enkel energi',
  schemaDesc: 'Billig strøm til spotpris uden tillæg. Variabel elpris efter markedspris. El tilbud med lav strømpris og gennemsigtig timepris. Abonnement fra kun 18 kr./md.',

  // Process
  processTitle: 'Skift til billigere el på 2 minutter',
  processSubtitle: 'Vi håndterer alt det praktiske med dit gamle\u00A0elselskab',
  step1Title: 'Vælg din billige elaftale',
  step1Text: 'Vælg mellem enkel kvartal, strøm eller\u00A0natur.',
  step2Title: 'Udfyld dine oplysninger',
  step2Text: 'Vi har brug for få oplysninger for at skifte dig\u00A0over.',
  step3Title: 'Vi klarer resten',
  step3Text: 'Vi opsiger hos dit gamle selskab og starter din nye\u00A0aftale.',
  chooseDurElAftale: 'Vælg din billige elaftale',

  // FAQ
  faqTitle: 'Ofte stillede spørgsmål om billig el',
  faq1Q: 'Hvad er forskellen mellem jeres billige elaftaler?',
  faq1A: 'enkel kvartal (18 kr./md) har kvartalsvis betaling – vores billigste el-abonnement. enkel strøm (28 kr./md) har månedlig betaling. enkel natur (48 kr./md) støtter danske naturprojekter med 20 kr./md. Alle giver dig el til lav pris via markedspris.',
  faq2Q: 'Er der bindingsperiode på jeres billige strøm-aftaler?',
  faq2A: 'Nej, alle vores billige elaftaler er uden binding. Du kan opsige når som helst og spar på strøm fra dag ét.',
  faq3Q: 'Hvor hurtigt kan jeg få billig strøm?',
  faq3A: 'Vi kan aktivere dig fra dag til dag. Vi håndterer alt det praktiske med dit gamle elselskab, så du hurtigt kan få lav strømpris.',
  faq4Q: 'Hvad koster det at skifte til en billig el-leverandør?',
  faq4A: 'Der er ingen etableringsgebyrer at skifte til enkel energi. Du får strøm til lav pris uden skjulte omkostninger.',

  // Final CTA
  finalCtaTitle: 'Klar til billig el?',
  finalCtaSubtitle: 'Spar penge på strøm med lav elpris og gennemsigtig strømpris. Skift til enkel i dag.',

  // Price breakdown
  upTo44Cheaper: 'OP TIL 44% BILLIGERE',
  avgSavings: 'Vores kunder sparer i gennemsnit ~18% vs. markedsprisen',
  savingsNotIncludingFree: '- og det er uden at medregne nedenstående gratis fordele',
  savingsNotIncludingFreeAbove: '- og det er uden at medregne ovenstående gratis fordele',
  whatDuPayEnkel: 'Hvad du betaler til enkel (inkl. abonnement)',
  inclSubscription: 'Inkl. abonnement',
  whatDuPayStateGrid: 'Stat & net',
  typicalTotalPrice: 'Typisk samlet elpris',
  elhandlerLabel: 'Elpris fra Enkel',
  netLabel: 'Net, tariffer, afgifter og moms',
  from2026: 'Fra 2026',

  // Detailed price breakdown
  priceExampleTitle: 'Sådan er prisen ovenfor bygget op',
  priceExampleIntro: 'Denne oversigt viser, hvordan den typiske totalpris ovenfor er sammensat. Dine faktiske regninger varierer med dit faktiske forbrug og aktuelle spotpriser.',
  consumptionBasis: 'Beregningsgrundlag: 6.000 kWh/år',

  // Elhandler section
  elhandlerSection: 'enkel (elhandler)',
  elhandlerExplanation: 'Dette er hvad du betaler til Enkel Energi. Vi fastsætter eller påvirker ikke net-tariffer eller afgifter.',
  spotPriceRow: 'Spotpris',
  spotPriceExampleValue: '65,49 øre/kWh',
  spotPriceExampleValueStrom: '65,49 øre/kWh',
  spotMarkupRow: 'Spotpris tillæg',
  markupZero: '0,00 øre/kWh',
  obligatoryFeesRow: 'Obligatoriske gebyrer',
  feesZero: '0,00 øre/kWh',
  subscriptionRow: 'Abonnement',
  subscription18: '2,88 øre/kWh',
  subscription28: '4,48 øre/kWh',
  subscription48: '4,48 øre/kWh',
  subscription18Monthly: '(18 kr./md)',
  subscription28Monthly: '(28 kr./md)',
  subscription48Monthly: '(48 kr./md)',
  natureDonation20: '1,60 øre/kWh',
  natureDonation20Monthly: '(20 kr./md)',
  natureDonationRow: 'Naturdonation',
  elhandlerTotal: 'Betaling for el',
  elhandlerTotalValue18: '68,37 øre/kWh',
  elhandlerTotalValue28: '69,97 øre/kWh',
  elhandlerTotalValue48WithNature: '71,57 øre/kWh',

  // Netselskab section
  netselskabSection: 'Dit Netselskab (eksempel: Radius Elnet)',
  netselskabExplanation: 'Dit netselskab vælges efter din bopæl. Disse priser er regulerede og uden for Enkel Energis kontrol.',
  distributionRow: 'Distribution',
  distributionValue: '34,17 øre/kWh',
  netSubscriptionRow: 'Abonnement',
  netSubscriptionValue: '2,94 øre/kWh',
  netSubscriptionNote: 'Fast månedligt beløb der dækker adgang til elnettet. Omregnet til øre/kWh baseret på 6.000 kWh/år for sammenlignelighed.',
  netselskabTotal: 'Betaling for distribution (Samlet)',
  netselskabTotalValue: '37,11 øre/kWh',

  // Energinet section
  energinetSection: 'Energinet',
  energinetExplanation: 'Energinet driver det overordnede elnet. Omkostningerne er ens uanset elleverandør.',
  transmissionTariffRow: 'Tariffer',
  transmissionValue: '13,50 øre/kWh',
  transmissionSubscriptionRow: 'Abonnement',
  transmissionSubscriptionValue: '1,21 øre/kWh',
  transmissionSubscriptionNote: 'Fast månedligt beløb omregnet til øre/kWh for sammenligning.',
  energinetTotal: 'Betaling for transmission (Samlet)',
  energinetTotalValue: '14,71 øre/kWh',

  // Public charges and VAT
  publicChargesSection: 'Beregnet el-afgift',
  elTaxRow: 'Beregnet el-afgift',
  elTaxValue: '1,00 øre/kWh',
  elTaxExplanation: 'Statens afgift på elforbrug fra 01.01. Fastsættes af staten og er ens hos alle elselskaber.',
  vatSection: 'Moms',
  vatRow: 'Moms (25%)',
  vatValue18: '30,27 øre/kWh',
  vatValue28: '30,67 øre/kWh',
  vatValue48: '30,94 øre/kWh',
  vatExplanation: 'Dansk moms på 25% tillægges alle priser på din elregning. Moms går til staten.',

  // Totals
  totalPriceRow: 'Samme totalpris som vist ovenfor',
  totalPriceValue18: '151,86 øre/kWh',
  totalPriceValue28: '153,46 øre/kWh',
  totalPriceValue48: '155,06 øre/kWh',
  
  // Subscription clarification
  subscriptionAlreadyIncluded: 'Disse månedlige beløb er allerede inkluderet i totalprisen ovenfor. De vises her for at illustrere, hvordan omkostningerne fremgår af din faktura.',

  // Additional info
  subscriptionFeesSection: 'Abonnement og gebyrer',
  monthlySubscriptionTotal: 'Abonnementsbetaling pr. måned',
  monthlySubscription18: '73,97 kr. (inkl. moms)',
  monthlySubscription28: '73,97 kr. (inkl. moms)',
  monthlySubscription48: '73,97 kr. (inkl. moms)',
  subscriptionBreakdown: 'Heraf abonnement el: 28,00 kr. (inkl. moms)',
  subscriptionTransport: 'Heraf abonnement transport: 45,97 kr. (inkl. moms)',
  obligatoryFees: 'Obligatoriske gebyrer:',
  obligatoryFeesNone: 'Ingen',

  // SEO section - transparent pricing
  transparentPricingTitle: 'Gennemsigtig elpris – sådan fungerer det',
  transparentPricingSubtitle: 'Hos enkel får du el efter markedspris uden skjulte tillæg',
  transparentPricingText1: 'Vi tilbyder billig el med gennemsigtig strømpris baseret på den rene el spotpris fra elbørsen.\nDet betyder, at du betaler den faktiske markedspris el – hverken mere eller mindre.',
  transparentPricingText2: 'Med vores spotpris elaftale får du variabel elpris der følger markedet.\nIngen tillæg ovenpå elprisen – kun et lavt, fast abonnement.',
  transparentBenefit1Title: 'El til markedspris',
  transparentBenefit1Text: 'Du får strøm til markedspris uden at vi lægger noget oveni. Vores elpris uden tillæg sikrer dig den lavest mulige pris.',
  transparentBenefit2Title: 'Variabel strømpris',
  transparentBenefit2Text: 'Med variabel strømpris følger din pris markedet. Det giver dig mulighed for at spare penge på el ved at forbruge når strøm spotprisen er lav.',
  transparentBenefit3Title: 'Præcis afregning',
  transparentBenefit3Text: 'Vælg mellem time-afregning eller 15-minutters afregning for endnu større besparelser. Med 15-min afregning kan Saving Mode optimere din opladning endnu mere præcist.',

  // Short card labels
  enkelPriceBreakdown: 'Elhandler (Enkel)',
  spotPrice: 'Spotpris',
  totalEnkel: 'I alt til enkel',
  stateAndGridBreakdown: 'Net, tariffer, afgifter og moms',
  distributionTransmission: 'Distribution + transmission',
  electricityTax: 'Elafgift',
  vat25: 'Moms (25%)',
  totalStateGrid: 'I alt',
  basedOn7500: 'Baseret på 15.000 kWh/år',
  basedOn15000: 'Eksempel: 6.000 kWh/år',
  freePaymentService: 'Betalingsservice inkluderet',
  freePaymentServiceGift: 'Betalingsservice gebyr uden omkostning – vi giver det med',
  secureMitIdBetal: 'Sikker tilmelding og betalingsservice uden gebyr',
  freeServiceAgreement: 'Serviceaftale inkluderet',
  subscription18Month: 'Abonnement (18 kr./md)',
  subscription28Month: 'Abonnement (28 kr./md)',
  subscription48Month: 'Abonnement (48 kr./md)',
  natureDonationLine: 'Naturdonation (20 kr./md)',
  durEnkelPrice: 'Din enkel-pris',
  moreInfoExpand: 'Mere information',
  lessInfoCollapse: 'Mindre information',
  yourEnkelPrice: 'Din enkel-pris',
  whatYouPayEnkel: 'Hvad du betaler til enkel (inkl. abonnement)',
  whatYouPayStateGrid: 'Stat & net',
  oneMonthNotice: '1 måneds opsigelsesvarsel',
};